<!-- <mat-grid-list flex cols="2" rowHeight="240px" gutterSize="0" class="grid-list">
  <mat-grid-tile *ngFor="let tile of myAntomy">
    <mat-card class="example-card" id="{{tile.id}}" (click)='redirectPage(tile.pageName)'>
      <mat-card-header>
        <mat-card-title>{{ tile.title }}</mat-card-title>
      </mat-card-header> -->

<!-- <img mat-card-image src="{{ tile.image_cardview }}" alt="{{ tile.alttext }}" /> -->

<!-- <div class="flip-box">
        <div class="flip-box-inner">
          <div class="flip-box-front">
            <img mat-card-image src="{{ tile.image_cardview }}" alt="{{ tile.alttext }}" />
          </div>
          <div class="flip-box-back">
            <img mat-card-image class="hvr-pulse-grow" src="{{ tile.image_cardview }}" alt="{{ tile.alttext }}"
              style="width: 100%; height: 120%;" />
          </div>
        </div>
      </div>

      <mat-card-footer>
        {{ tile.desc }}
      </mat-card-footer>
    </mat-card>
  </mat-grid-tile>
</mat-grid-list> -->

<div style="text-align: center; margin-top: 60px; margin-bottom: -58px;">
  <span class="panel-m"><img id="panel-m" (click)="redirectPage('panel')" class="dot" src="./assets/img/panelmemberimg.png"></span>
</div>
<div style="text-align:center">
  <span class="candidate"><img id="candidate" (click)="redirectPage('candidate')" class="dot"
      src="./assets/img/candidateimg.png" /></span>
  <span class="process"><img id="process" (click)="redirectPage('process')" class="dot" src="./assets/img/processimg.png" /></span>
</div>
<div style="text-align: center; margin-top: -58px">
  <span class="status"><img id="status" (click)="redirectPage('status')" class="dot" src="./assets/img/statusimg.png" /></span>
</div>

<div style="text-align: center; margin-top: 40px; margin-bottom: 40px">
  <b class="processsStatus">CANDIDATE <span class="arrow">&#8680;</span> PANEL MEMBER <span class="arrow">&#8680;</span>
    PROCESS <span class="arrow">&#8680;</span> STATUS</b>
</div>